export default "__VITE_ASSET__CjGb3gzf__"